import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import LogosMarquee from "@/components/site/LogosMarquee";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import ERPs from "@/components/site/ERPs";
import Methodology from "@/components/site/Methodology";
import Academy from "@/components/site/Academy";
import Results from "@/components/site/Results";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFAB from "@/components/site/WhatsAppFAB";
import ChatBot from "@/components/site/ChatBot";

export default function Landing() {
  return (
    <div className="relative overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <LogosMarquee />
        <About />
        <Services />
        <ERPs />
        <Methodology />
        <Academy />
        <Results />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFAB />
      <ChatBot />
    </div>
  );
}
